export const secret = process.env.REACT_APP_SECRET;
export const anonymousSecret = process.env.REACT_APP_ANONYMOUS_SECRET;
export const chatBotSecret = process.env.REACT_APP_CHATBOT_SECRET;
export const baseUrl = process.env.REACT_APP_API_URL;
export const mainUrl = process.env.REACT_APP_URL;
export const webUrl = process.env.REACT_APP_WEB_URL;
export const webApiUrl = process.env.REACT_APP_WEB_API_URL;
export const mapSecret = process.env.REACT_APP_GOOGLE_SECRET;
export const subUrl = "/en/";
